export const MANHATTAN_LOGO = "/images/logos-saas/ot-manhattan.svg";

export const MANHATTAN_COLORS = {
    main: "#1565c0",
    mainHover: "#0d47a1",
    mainLight: "#1976d2",
    mainLightHover: "#1565c0",
    grad: "linear-gradient(135deg, #0d47a1 0%, #1565c0 100%)",
};

/**
 * True if the current session comes from the Manhattan SSO.
 *
 * @returns {boolean}
 */
export function isManhattanSession() {
    return Boolean(window.__SSO_CONTEXT__ && window.__SSO_CONTEXT__.isManhattan);
}

/**
 * Key used by a layout to provide its theme to teleported components (modals).
 */
export const LAYOUT_THEME_KEY = "layoutTheme";

/**
 * Theme class and CSS variables to apply on the layout root and on teleported components.
 *
 * @param {boolean} isManhattan
 * @returns {{ class: string|null, style: Object<string, string> }}
 */
export function manhattanLayoutTheme(isManhattan) {
    if (!isManhattan) {
        return { class: null, style: {} };
    }

    return {
        class: "manhattan-theme",
        style: {
            "--main-color": MANHATTAN_COLORS.main,
            "--main-color-hover": MANHATTAN_COLORS.mainHover,
            "--main-color-light": MANHATTAN_COLORS.mainLight,
            "--main-color-light-hover": MANHATTAN_COLORS.mainLightHover,
            "--main-grad": MANHATTAN_COLORS.grad,
        },
    };
}
